import React from "react";
import ReactDOM from "react-dom/client";

import { AccountDrawer, AccountDrawerProps } from "@app/scripts/react-account-drawer/components/AccountDrawer";

class AccountDrawerElem extends HTMLElement {
  static observedAttributes = ["image", "mobile-image", "create-image", "mobile-create-image"];

  connectedCallback() {
    const props: AccountDrawerProps = {
      content: {},
      image: {
        url: this.getAttribute("image") ?? "",
        alt: "Sign in to your account",
      },
      mobileImage: {
        url: this.getAttribute("mobile-image") ?? "",
        alt: "Sign in to your account",
      },
      createImage: {
        url: this.getAttribute("create-image") ?? "",
        alt: "Sign in to your account",
      },
      mobileCreateImage: {
        url: this.getAttribute("mobile-create-image") ?? "",
        alt: "Sign in to your account",
      },
    };
    const script = this.querySelector("[data-textcontent");

    try {
      props.content = JSON.parse(script?.innerHTML ?? "{}");
    } catch (error) {
      console.error(error);
    }

    const root = ReactDOM.createRoot(this);

    root.render(<AccountDrawer {...props} />);
  }
}

customElements.define("account-drawer", AccountDrawerElem);
